import React, { CSSProperties, Fragment, ReactNode } from "react";
import FlexBox from "../../../../Components/FlexBox/FlexBox";
import Typography  from "../../../../Foundation/Typography/Typography";
import { IFooterLinkItem } from "../FooterLinks/FooterLinks";
import { _FooterLinksAnchor } from "../FooterLinks/FooterLinks.styled";

interface ILegalMentionProps {
  links: IFooterLinkItem[];
  description?: ReactNode;
}

const LegalMention = (props: ILegalMentionProps) => {
  const { links, description } = props;
  const linkStyle: CSSProperties = { display: "inline-block" };
  return (
    <FlexBox direction="column" gap={16} style={{ maxWidth: 230 }}>
      <div>
        {links.map((link, index) => {
          const { label, url, onClick } = link;
          const separator = (
            <Typography style={linkStyle} variant="ui4" color="greyText">
              {index > 0 ? <>&nbsp;/&nbsp;</> : ""}
            </Typography>
          );

          const textRender = (
            <Fragment>
              <Typography
                style={linkStyle}
                variant="ui4"
                className="link-text"
                color="greyText"
              >
                {label}
              </Typography>
            </Fragment>
          );
          if (onClick) {
            return (
              <Fragment key={index}>
                {separator} {textRender}
              </Fragment>
            );
          }
          return (
            <Fragment key={index}>
              {separator}
              <_FooterLinksAnchor
                style={linkStyle}
                key={index}
                href={url || "#"}
                onClick={onClick}
              >
                {textRender}
              </_FooterLinksAnchor>
            </Fragment>
          );
        })}
      </div>
      <Typography variant="ui4" color="greyText">
        {description}
      </Typography>
    </FlexBox>
  );
};

export default LegalMention;
